import { defineStore, storeToRefs } from 'pinia'
import { reactive, ref, watch } from 'vue'

import useAuthUser from '@/composables/useAuthUser'

import { Company } from '@/modules/companies/interfaces/company'
import { CefsFilters } from '@/modules/trips/interfaces/CefFilters'
import { useStateStore } from '@/stores/state'

export const useCefFilterStore = defineStore('cefFilter', () => {
	const { user } = useAuthUser()
	const { states } = storeToRefs(useStateStore())

	const currentTab =
		new URLSearchParams(window.location.search).get('tab') ?? 'current'

	const params: { [key: string]: any } = reactive<CefsFilters>({
		company: user.value?.internal ? undefined : user.value?.companyId,
		travelerName: '',
		// Búsqueda global (CefFilter::search) y su desglose por pestaña. Declarados
		// aquí y no agregados al vuelo para que formen parte del objeto reactivo
		// desde el inicio.
		search: '',
		tabCounts: null,
		order: 'desc',
		status: undefined,
		progressStage:
			currentTab === 'cancelled' || currentTab === 'solicitudes' ?
				null
			:	currentTab,
		cef: undefined,
		confirmation: '',
		name: '',
		creatorName: '',
		channel: undefined,
		creationDates: [],
		dates: [],
		folio: undefined,
		hasLetter: undefined,
		service: undefined,
		supplierName: '',
		tripReason: '',
		perPage: 15,
		onlyRequests: currentTab === 'solicitudes' ? true : null,
	})

	watch(
		states,
		(loaded) => {
			if (loaded.length && currentTab === 'cancelled' && !params.status) {
				params.status = loaded.find((s) => s.displayName === 'Cancelado')?.id
			}
		},
		{ immediate: true }
	)

	const selectedCompany = ref<Company>()

	return {
		selectedCompany,
		params,

		resetFilters() {
			Object.keys(params).forEach((key) => {
				if (key === 'order') params[key] = 'desc'
				if (key === 'status') {
					params['status'] = '3'
					params['progressStage'] = null
				}

				if (key === 'company') {
					params[key] = user.value?.internal ? undefined : user.value?.companyId
				}
				params[key] = null
			})
		},
	}
})
